import React, { useState } from "react";
import Calendar from "../../assets/images/icons/calendar-1.svg";
import DateRangeFilterMenu from "../DateRangeFilterMenu/DateRangeFilterMenu";

const DateRangeSelectButton = ({
  onApply,
  onReset,
  appliedFrom,
  appliedTo,
  buttonLabel = "Select Date",
  wrapperClassName = "",
}) => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleDropdown = () => {
    setActiveDropdown((current) => (current === 1 ? null : 1));
  };

  const closeDropdown = () => setActiveDropdown(null);

  const handleApply = (start, end) => {
    onApply(start, end);
    closeDropdown();
  };

  const handleReset = () => {
    onReset?.();
    closeDropdown();
  };

  return (
    <div className={`date-range-select ${wrapperClassName}`.trim()}>
      <div className="dropdown position-relative d-inline-block">
        <button type="button" className="btn btn-primary px-4 rounded-2" onClick={toggleDropdown}>
          {buttonLabel} <img src={Calendar} style={{ height: "18px" }} className="ml-4" alt="" />
        </button>
        <div
          className={`dropdown-menu dropdown-menu-end rounded-14 border-0 shadow-lg p-4 date-range-select__menu ${
            activeDropdown === 1 ? "show" : ""
          }`}
        >
          <DateRangeFilterMenu
            isOpen={activeDropdown === 1}
            onApply={handleApply}
            onReset={onReset ? handleReset : undefined}
            appliedFrom={appliedFrom}
            appliedTo={appliedTo}
          />
        </div>
      </div>
    </div>
  );
};

export default DateRangeSelectButton;
